import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectExtensionStatus } from 'flow/selectors/ExtensionSelectors';
import ExtensionContactAvatar from 'flow/components/ui-components/ExtensionContactAvatar';
import { isTypeExtensionKey } from 'flow/utils/extension-utils-TW';
import { AvatarSize } from 'flow/components/ui-components/ChatAvatar';

interface Props {
    sender: string;
    ignoreAvatarResource?: boolean;
    size?: AvatarSize;
    lazyLoad?: boolean;
}

const SenderAvatar = ({
    sender,
    ignoreAvatarResource,
    size,
    lazyLoad,
}: Props) => {
    const senderIsExtension = isTypeExtensionKey(sender);
    const status = useAppSelector((state) =>
        senderIsExtension ? selectExtensionStatus(state, sender) : undefined,
    );

    return (
        <ExtensionContactAvatar
            extensionKey={senderIsExtension ? sender : undefined}
            status={status}
            size={size}
            ignoreAvatarResource={ignoreAvatarResource}
            lazyLoad={lazyLoad}
        />
    );
};

export default SenderAvatar;
